import {
  WEEK_DAYS,
  generateTimeOptions,
  formatTime,
  getSlotList,
  getTimeSlotClass as getTimeSlotClassBase,
  getTimeSlotsClass as getTimeSlotsClassBase,
  getRandomInt,
} from "../utils/tarifSharedUtils";
import { useCurrency } from "../utils/helpers";

// Re-export shared utilities
export {
  WEEK_DAYS,
  generateTimeOptions,
  formatTime,
  getSlotList,
  getRandomInt,
};

export const periodColors = [
  "#1976D2", // Blue
  "#FFB300", // Amber
  "#43A047", // Green
  "#E53935", // Red
  "#8E24AA", // Purple
  "#00ACC1", // Cyan
  "#F4511E", // Orange
  "#3949AB", // Indigo
  "#6D4C41", // Brown
  "#C0CA33", // Lime
  "#5E35B1", // Deep Purple
  "#00897B", // Teal
  "#FDD835", // Yellow
  "#D81B60", // Pink
  "#757575", // Grey
  "#1E88E5", // Light Blue
  "#7CB342", // Light Green
  "#F06292", // Light Pink
];

export const DEMAND_NOTICE = {
  1: {name: "Demand Charges",value: 0},
  2: {name: "Demand Value",value: 0},
  3: {name: "Minimum Billing",value: 0},
  4: {name: "Penalty",value: 0},
  5: {name: "Subscribed Block",value: 0},
  6: {name: "Subscribed Block Rate",value: 0},
  7: {name: "Rachet Demand",value: 100},
  // 8: {name: "Fixed Charges",value: 0},
  9: {name: "Variable Charges",value: 0}
}

// DEMAND_UNITS as a hook to use currency from useCurrency
export const useDemandUnits = () => {
  const currency = useCurrency();
  return {
    1: `(${currency}/kW)`,
    2: "(kW)",
    3: "(%)",
    4: `(${currency}/kW)` ,
    5: "(kW)",
    6: `(${currency}/Block)`,
    7: "(%)",
    8: `(${currency})`,
    9: `(${currency})/kWh`
  };
}

export const getTimeSlotClass = (currentTimeSlot, slotList) => {
  return getTimeSlotClassBase(currentTimeSlot, slotList, periodColors);
};

export const getUsedWeekdays = (selectedSeason, activeDemandType) => {
  const usedWeekdays = new Set();
  selectedSeason?.periods?.forEach((demandType, index) => {
    if (index !== activeDemandType) {
      demandType.weekDays.forEach((day) => usedWeekdays.add(day));
    }
  });
  return usedWeekdays;
};

export const getTimeSlotsClass = (currentTimeSlot, slotList, periodColor) => {
  return getTimeSlotsClassBase(currentTimeSlot, slotList, periodColors);
};
